// import the styles for whole app
import './scss/bootstrap.scss';
import './scss/nc4.scss';
import './scss/utilities.scss';
// Tailwind is imported AFTER Bootstrap so its utilities win the cascade during migration
import './scss/tailwind.css';

// datepicker
import "flatpickr/dist/themes/light.css";
import 'react-date-range/dist/styles.css'; // main css file
//import 'react-date-range/dist/theme/default.css'; // theme css file
import 'react-loading-skeleton/dist/skeleton.css'; //skeleton loading
import React from 'react';
import {Provider as ReduxProvider} from 'react-redux';
import {Provider as RollbarProvider} from '@rollbar/react'

import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './utils/snowplow';
// before anything renders: keeps a third-party DOM rewrite from crashing React's commit phase
import {setDomMutationReporter} from './utils/domMutationGuard.ts';

import Router from 'components/router/Router.component.jsx';
import store from 'components/store/Store.component.jsx';
import {AppTooltip} from 'components/tooltip/AppTooltip.component.jsx';
import {syncDocumentLanguage} from 'components/translations/documentLanguage.function.ts';
import {createRoot} from 'react-dom/client';
import {launchDarkly} from "utils/launchDarkly.ts";
import {buildRollbarConfig} from "utils/rollbarConfig.function.ts";
import Rollbar from 'rollbar';
import {AppErrorBoundary, LastResortBoundary} from 'components/errorpage/AppErrorBoundary';


const rollbarConfig = buildRollbarConfig(window.ENVIRONMENT);
// built here rather than by the provider, so code outside React - the DOM guard above - can report too
const rollbar = new Rollbar(rollbarConfig);

setDomMutationReporter((message, context) => rollbar.warning(message, context));
syncDocumentLanguage(store);


const App = () => {
    return (<RollbarProvider instance={rollbar}>
        <LastResortBoundary>
            <ReduxProvider store={store}>
                {/* inside the provider, so a crash shows the localised error page instead of a blank screen */}
                <AppErrorBoundary>
                    <Router/>
                    {/* The single ReactTooltip instance every `<Tooltip>` trigger points at. */}
                    <AppTooltip/>
                    <ToastContainer
                        position={'top-right'}
                        autoClose={2500}
                        hideProgressBar={true}
                        draggable
                        closeButton={false}
                    />
                </AppErrorBoundary>
            </ReduxProvider>
        </LastResortBoundary>
    </RollbarProvider>);
}

const container = document.getElementById('root');
launchDarkly.createAnonymousClient().then(() => {
    const root = createRoot(container); // createRoot(container!) if you use TypeScript
    root.render(<App/>);
});
